import MovieList from '../../../utils/MovieList';
import { NOW_PLAYING_MOVIES } from '../../../../utils/constants';
import { MovieListType } from '../../../../types';

const SecondaryContainer = ({
  movies,
  listRef,
  isLoading,
  isHomePage,
}: MovieListType) => {
  return (
    <div className='dark:bg-gray-900 bg-gray-50'>
      <div
        className={`mt-0 relative z-10 px-2 md:pl-6${
          isHomePage ? ' md:-mt-52' : ''
        }`}>
        <MovieList
          title={NOW_PLAYING_MOVIES.value}
          movies={movies}
          listRef={listRef}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default SecondaryContainer;
